import Sleeping from './Adult/fever/sleeping.svg';
import Water from './Adult/fever/water.svg';
import Cloth from './Adult/fever/cloth.svg';
import Shirt from './Adult/fever/shirt.svg';
import Pills from './Adult/fever/pills.svg';
// diarrhea
import ORS from './Adult/diarrhea/ORS.svg';
import WashHands from './Adult/diarrhea/washhands.svg';
import WashDishes from './Adult/diarrhea/dishes.svg';
import BreastFeed from './Adult/diarrhea/breastfeed.svg';
// vomitting
import SipORS from './Adult/vomitting/SipsORS.svg';
import Sitting from './Adult/vomitting/sitting.svg';
// rash
import Medicine from './Adult/rash/medicine.svg';
import CleanPlace from './Adult/rash/clean.svg';
import Creams from './Adult/rash/creams.svg';
import Rash from './Adult/rash/rash.svg';
import GiveFood from './Adult/rash/giveFood.svg';
// cough
import FoodDrink from './Adult/cough/foodanddrink.svg';
// import Rest from "../../../icons/StaticPages/Symptoms/Adult/cough/rest.svg";
import Resting from './Adult/cough/resting.svg';
import HardBreathing from './Adult/cough/hardbreathing.svg';
import WarmClothes from './Adult/cough/warmclothes.svg';
// ear pain
import InsideEar from './Adult/earpain/InsideEar.svg';
import WipeOutside from './Adult/earpain/dry.svg';
import Painkiller from './Adult/earpain/painkiller.svg';
import DryEar from './Adult/earpain/dryear.svg';
import OutsideEar from './Adult/earpain/outside.svg';

const ADULTSIGNSANDSYMPTOMSIMAGES = {
  Sleeping,
  Water,
  Cloth,
  Shirt,
  ORS,
  WashDishes,
  WashHands,
  BreastFeed,
  SipORS,
  Sitting,
  Medicine,
  CleanPlace,
  GiveFood,
  Rash,
  Creams,
  FoodDrink,
  Resting,
  HardBreathing,
  WarmClothes,
  InsideEar,
  DryEar,
  WipeOutside,
  Painkiller,
  OutsideEar,
  Pills,
};

export default ADULTSIGNSANDSYMPTOMSIMAGES;
